import { PHONES } from "./constants/phoneCode";

export const getUniquePhoneCodeItems = () => {
  const seen = new Set<string>();

  return PHONES.filter(p => {
    if (seen.has(p.code)) return false;
    seen.add(p.code);
    return true;
  })
    .sort((a, b) => {
      const codeA = parseInt(a.code.replace(/\D/g, ""), 10);
      const codeB = parseInt(b.code.replace(/\D/g, ""), 10);
      return codeA - codeB;
    })
    .map(p => ({
      name: p.code,
      id: p.code,
    }));
};
